import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { Observable } from "rxjs";
import { LoggerService } from "src/app/services/infra/logger/logger.service";

enum AuthErrorType {
    notInOrganization = "notInOrganization", // When user tries login to organization he is not part of
    invitationExpired = "invitationExpired", // When invitation link is expired or already used
    secretExpired = "secretExpired", // All other Auth0 errors are considered as "secretExpired" because this specific case couldn't be handled during login process
}

@Component({
    selector: "app-error-login",
    templateUrl: "./error-login.component.html",
    styleUrls: ["./error-login.component.scss"],
})
export class ErrorLoginComponent implements OnInit {
    public error$: Observable<Error> = this._auth.error$;
    public AuthErrorType = AuthErrorType;
    public errorType: AuthErrorType.notInOrganization | AuthErrorType.invitationExpired | AuthErrorType.secretExpired = AuthErrorType.secretExpired;
    private _hasError = false;

    constructor(
        private _logger: LoggerService,
        private _auth: AuthService,
        private _router: Router,
    ) {
        this.error$.subscribe((error) => {
            if (error.message.includes("user") && error.message.includes("is not part of the") && error.message.includes("organization")) {
                this.errorType = AuthErrorType.notInOrganization;
            }

            if (error.message.includes("invitation not found or already used")) {
                this.errorType = AuthErrorType.invitationExpired;
            }

            this._hasError = true;
            this._logger.warn(
                `Attention! A customer failed to login to his organization. This usually indicates an error of the connection associated with the customer organization. For example, an error can be an expired secret in customer Identity Provider (such as AAD). Error from Auth0: ${error}`,
            );
        });
    }

    ngOnInit(): void {
        if (!this._hasError) {
            this._router.navigateByUrl("/app");
        }
    }
}
